/** Renovación por sesión y reanudación visible, sin solicitar permiso. */
export function adminPushLifecycle(restore: (owner: string, force?: boolean) => Promise<unknown>, now = Date.now) {
  let current: string | undefined, active = true, lastAttempt = -Infinity;
  let flight: Promise<void> | null = null, queuedForce = false;
  function resume(force = false): void {
    if (!active || !current) return;
    if (flight) { queuedForce ||= force; return; }
    if (!force && now() - lastAttempt < 60_000) return;
    const owner = current; lastAttempt = now();
    const run = Promise.resolve().then(() => restore(owner, force)).then(() => undefined, () => undefined);
    flight = run;
    void run.finally(() => { if (flight === run) { flight = null; if (queuedForce) { queuedForce = false; resume(true); } } });
  }
  return {
    update(owner: string | undefined, admin: boolean) {
      const selected = admin ? owner : undefined;
      if (selected !== current) { current = selected; lastAttempt = -Infinity; flight = null; queuedForce = false; }
      resume();
    },
    resume,
    stop() { active = false; current = undefined; },
  };
}
